export const ROUTE_APP_HOME = "/home";
export const ROUTE_APP_LANDING = "/";
export const ROUTE_APP_ERROR = "/error";
export const ROUTE_APP_ERROR_UNAUTHORIZED = "/error_unauthorized";
